"use client";

import posthog from "posthog-js";
import { PostHogProvider as PHProvider } from "posthog-js/react";
import { useEffect } from "react";
import { SuspendedPostHogPageView } from "./PostHogViewCapture";

interface Props {
	token: string;
	apiHost: string;
	children: React.ReactNode;
}

export const PostHogProvider: React.FC<Props> = ({
	children,
	token,
	apiHost,
}) => {
	useEffect(() => {
		posthog.init(token, {
			api_host: "/ingest",
			ui_host: apiHost,
			capture_pageview: false,
			capture_pageleave: true,
		});
	}, []);

	return (
		<PHProvider client={posthog}>
			<SuspendedPostHogPageView />
			{children}
		</PHProvider>
	);
};
